// Getters
export const dashboard = (state) => {
  return state.dashboard.data || []
}
export const dashboardLoading = (state) => {
  return state.dashboard.loading
}
export const dashboardLastUpdate = (state) => {
  return state.dashboard.lastUpdate
}

export const permissions = (state) => {
  return state.permissions.data || []
}
export const permissionsLoading = (state) => {
  return state.permissions.loading
}
export const permissionsLastUpdate = (state) => {
  return state.permissions.lastUpdate
}

export const updateDash = (state) => {
  return state.updateDash.data || {}
}
export const updateDashLoading = (state) => {
  return state.updateDash.loading
}
export const updateDashLastUpdate = (state) => {
  return state.updateDash.lastUpdate
}
export const embed = (state) => {
  return state.embed.data || []
}
export const embedLoading = (state) => {
  return state.embed.loading
}
export const embedLastUpdate = (state) => {
  return state.embed.lastUpdate
}

export const cache = (state) => {
  return state.cache.data || []
}
export const cacheLoading = (state) => {
  return state.cache.loading
}
export const cacheLastUpdate = (state) => {
  return state.cache.lastUpdate
}

export const statusCache = (state) => {
  return state.statusCache.data || {}
}
